export default[
    {
        path: 'saasProduct',
        name: 'SaasProduct',
        component: () => import(/* webpackChunkName: "saasManage" */ '@/views/sale/saasManage/index.vue'),
    },
];
